import {
  SET_SHOW_SIDEBAR,
  SET_ACTIVE_MENU_ITEM
} from '../constants/AppConstants';

const initialState = {
  showSidebar: true,
  activeMenuItem: null,
}

const objectAssign = Object.assign || require('object.assign');

export default (state = initialState, action = null) => {
  switch (action.type) {
    case SET_SHOW_SIDEBAR:
      return objectAssign({}, state, {
				showSidebar: action.showSidebar
      });
    case SET_ACTIVE_MENU_ITEM:
      return objectAssign({}, state, {
        activeMenuItem: action.activeMenuItem
      });
		default:
      return state;
  }
};